module.exports = __webpack_public_path__ + "img/gold3.6efb4572.png";